import FieldRow from 'components/FormElements/FieldRow';
import { Button } from '@mui/material';
import {
  dateToLabel,
  getCompanyLabel,
  numberToDisplayString,
} from 'further-ui/utils';
import ButtonGroup from 'components/ButtonGroup';
import RecordView from 'components/RecordView';
import { round } from 'lodash';

const SummaryStep = ({
  company,
  shareSplitDate,
  shareSplitFactor,
  currentSharePriceDisplay,
  newSharePriceDisplay,
  onSubmit,
  onBack,
  isSubmitting,
}) => {
  return (
    <RecordView>
      <p>
        You are attempting to split the shares by a factor of{' '}
        <strong>{shareSplitFactor}</strong>. The new share price will be{' '}
        <strong>{newSharePriceDisplay}</strong>
      </p>
      <FieldRow title="Company" centerTitle>
        {getCompanyLabel(company.data)}
      </FieldRow>
      <FieldRow title="Share split date" centerTitle>
        {dateToLabel(shareSplitDate)}
      </FieldRow>
      <FieldRow title="Current share price" centerTitle>
        {currentSharePriceDisplay}
      </FieldRow>
      <FieldRow title="Current shareholding" centerTitle>
        {numberToDisplayString(company.data?.currentShares)}
      </FieldRow>
      <FieldRow title="Share split factor" centerTitle>
        {shareSplitFactor}
      </FieldRow>
      <FieldRow title="New share price" centerTitle>
        {newSharePriceDisplay}
      </FieldRow>
      <FieldRow title="New shareholding" centerTitle>
        {numberToDisplayString(
          round(company.data?.currentShares * shareSplitFactor, 2),
        )}
      </FieldRow>
      <ButtonGroup>
        <Button
          onClick={onBack}
          variant="outlined"
          style={{ marginRight: '0.5rem' }}
          disabled={isSubmitting}
        >
          Back
        </Button>
        <Button
          onClick={onSubmit}
          variant="contained"
          color="primary"
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          Submit
        </Button>
      </ButtonGroup>
    </RecordView>
  );
};

export default SummaryStep;
